import { QueryClient } from '@tanstack/react-query'

export const CoworkingQueryClient = new QueryClient()
